import React from 'react';
import RcCheckbox from 'rc-checkbox';
import bemCn from 'bem-cn';
import 'rc-checkbox/assets/index.css';
import './style.scss';

const b = bemCn('sniff-checkbox');

const SniffCheckbox = ({ label, fieldRef, className, labelClassName, error, children, ...rest }) => {
    const labelText = children || label;

    return (
        <label className={b.mix(className).mix(error ? 'error' : '')} style={rest.disabled ? { cursor: 'default' } : {}}>
            <RcCheckbox ref={fieldRef} {...rest} />
            {labelText && <span className={b('checkbox-label-text').mix(`${labelClassName} body-copy-medium`)}>{labelText}</span>}
        </label>
    );
};

export default SniffCheckbox;
